import { useEffect } from 'react'

/**
 * Phase 14b — the old open mentor-portal therapist application page is retired in favour of the
 * public /apply surface (organic + invitation-gated paths). This stub redirects any lingering
 * link to /apply so we don't break existing communications.
 */
export default function MentorTherapistApplicationPage() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace('/apply')
    }
  }, [])
  return null
}
